/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferCustomersControllerGetCustomerQueryResponse, TransferCustomersControllerGetCustomerPathParams, TransferCustomersControllerGetCustomer400, TransferCustomersControllerGetCustomer401, TransferCustomersControllerGetCustomer403, TransferCustomersControllerGetCustomer404 } from "../../models/transferCustomersController/TransferCustomersControllerGetCustomer";

function getTransferCustomersControllerGetCustomerUrl(salesforceId: TransferCustomersControllerGetCustomerPathParams["salesforceId"]) {
  const res = { method: 'GET', url: `/api/v1/transfer-customers/${salesforceId}` as const }  
  return res
}

/**
 * @summary Get customer details from 1.0 database
 * {@link /api/v1/transfer-customers/:salesforceId}
 */
export async function transferCustomersControllerGetCustomer(salesforceId: TransferCustomersControllerGetCustomerPathParams["salesforceId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TransferCustomersControllerGetCustomerQueryResponse, ResponseErrorConfig<TransferCustomersControllerGetCustomer400 | TransferCustomersControllerGetCustomer401 | TransferCustomersControllerGetCustomer403 | TransferCustomersControllerGetCustomer404>, unknown>({ method : "GET", url : getTransferCustomersControllerGetCustomerUrl(salesforceId).url.toString(), ... requestConfig })  
  return res.data
}